import axios from 'axios';

export const getConfig = brand => axios.get(`${process.env.API}/config/${brand}`); // eslint-disable-line